import { render } from "./TestTypeDotExplanation.vue?vue&type=template&id=c56788b8"
import script from "./TestTypeDotExplanation.vue?vue&type=script&lang=js"
export * from "./TestTypeDotExplanation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__